export default "__VITE_ASSET__bb8abd73__"